import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'

import Loader from '../Loader/Loader'
import { firestore } from '../../firebase'
import PostTemplate from '../Post/PostComponents/PostTemplate';

function FilterRecipes(props) {


    const [posts, setPosts] = useState([]);
    const [filteredPosts, setFilteredPosts] = useState([])
    const [isLoading, setIsloading] = useState(true);

    const [searchTerm, setSearchTerm] = useState("")
    const [requestCount, setRequestCount] = useState(0)

    const postsPerPage = props.postsPerPage;
    const page = props.page;

    useEffect(() => {
        async function getBlogPosts(page) {

            try {
                //console.log(page)
                setIsloading(true)
                const postsRef = firestore.collection("recipes")

                postsRef.onSnapshot(({docs}) => {
                    const posts = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    setPosts(posts)
                    setFilteredPosts(posts)
                })
                
            } catch (error) {

            }
            setIsloading(false)

        }
        getBlogPosts(page)
    }, [page, postsPerPage])

    useEffect(() => {
        setIsloading(true)
        const delay = setTimeout(() => {
            setRequestCount(requestCount+1)
        }, 500)
        setIsloading(false)
        return () => clearTimeout(delay)

    }, [searchTerm])

    useEffect(() => {

        if (requestCount) {
            setIsloading(true)
            const filteredPosts = posts.filter(post => {
                console.log(post.title, post.title.includes(searchTerm), searchTerm)
                return post.title.includes(searchTerm) || post.description.includes(searchTerm) || post.author_name.includes(searchTerm)
            })
            setFilteredPosts(filteredPosts)
            setIsloading(false)
        }

    }, [requestCount])

    function handleInput(e) {
        const value = e.target.value
        setSearchTerm(value)
        
    }

    if (isLoading) return (

        <div>
            <Loader />
        </div>

    )

    return (
        <div>
            <div className="search-overlay-top shadow-sm">
                <div className="container container--narrow">
                    <label htmlFor="live-search-field" className="search-overlay-icon">
                    <i className="fas fa-search"></i>
                    </label>
                    <input onChange={handleInput} autoFocus type="text" autoComplete="off" id="live-search-field" className="live-search-field" placeholder="Søk oppskrifter" />
                </div>
            </div>

            <div className="container">

                <div className="row">
                    {filteredPosts.map(post => {

                        const string = post.title;
                        const stringLength = string.length
                        const length = 27;
                        let formattedTitle, trimmedTitle
                        if (stringLength > length) {
                            trimmedTitle = string.substring(0, length) 
                            formattedTitle = trimmedTitle + "..."
                            console.log("Formatted Title: ", formattedTitle)
                        } else {
                            formattedTitle = post.title
                        }
                        


                        const date = post.date.toDate()
                        const dateFormatted = `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;
                        return (
                            <PostTemplate
                                key={post.id}
                                title={formattedTitle}
                                author={post.author_name}
                                postId={post.id}
                                dateFormatted={dateFormatted}
                                imageUrl={post.imageUrl}
                            />
                            
                        )
                        
                    })}
                </div>
            </div>
        </div>
    )
    

}
export default FilterRecipes